module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "home-body"
  }, [_vm._c('div', {
    staticClass: "container xs-pt-30 xs-pb-50"
  }, [_vm._c('h1', {
    staticClass: "serif"
  }, [_vm._v("Feedback Form")]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('InquiryForm', {
    attrs: {
      "subject": "Feedback form"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23a11ef4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/home/FeedbackFormPage.vue
// module id = 635
// module chunks = 1